
const videos = document.querySelectorAll('[data-behaviour="video"]');

const loadVideos = () => {

    if (videos && videos.length > 0) {

        videos.forEach((video) => {

            let sources = video.querySelectorAll('source');

            sources.forEach((source) => {

                const src = window.innerWidth < 768 && source.dataset.srcMobile ? source.dataset.srcMobile : source.dataset.src;
                source.setAttribute('src', src);
                video.load();

            });

        });
    }

}

loadVideos();